<template>
  <Teleport to="body">
    <div class="toast-container" aria-live="polite" aria-atomic="true">
      <TransitionGroup name="toast">
        <ToastItem
          v-for="item in toast.items"
          :key="item.id"
          :id="item.id"
          :type="item.type"
          :message="item.message"
          :duration="item.duration"
          @dismiss="toast.dismiss"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToastStore } from '@modules/shared/stores/toast'
import ToastItem from './ToastItem.vue'

const toast = useToastStore()
</script>
